var map = {
	"./en/appStore.json": 2035,
	"./en/privacy.json": 7005,
	"./en/terms.json": 1734,
	"./zh/appStore.json": 5204,
	"./zh/privacy.json": 6368,
	"./zh/terms.json": 4723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;